import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import es_ES from '@react-pdf-viewer/locales/lib/es_ES.json';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import './pdfViewer.css';

const PdfViewer = ({ pdf, className }) => {
  const renderToolbar = (Toolbar) => (
    <Toolbar>
      {(slots) => {
        const {
          CurrentPageInput,
          Download,
          EnterFullScreen,
          GoToNextPage,
          GoToPreviousPage,
          NumberOfPages,
          Zoom,
          ZoomIn,
          ZoomOut,
        } = slots;

        return (
          <div className='d-flex justify-content-between w-100 pdf-custom-container'>
            <div>
              <div className='d-flex align-items-center h-100'>
                <GoToPreviousPage />
                <CurrentPageInput /> / <NumberOfPages />
                <GoToNextPage />
              </div>
            </div>
            <div className='d-flex align-items-center'>
              <div className='d-flex'>
                <ZoomOut />
                <Zoom />
                <ZoomIn />
              </div>
              <div className='d-flex'>
                <EnterFullScreen />
                <Download />
              </div>
            </div>
          </div>
        );
      }}
    </Toolbar>
  );

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    sidebarTabs: () => [],
    renderToolbar,
  });

  return (
    <Worker workerUrl='https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js'>
      <div className={`position-relative ${className}`}>
        <Viewer
          fileUrl={pdf}
          plugins={[defaultLayoutPluginInstance]}
          localization={es_ES}
          defaultScale={1}
        />
      </div>
    </Worker>
  );
};

export default PdfViewer;
